import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import stepStyle from "assets/jss/style-component/components/stepStyle.js";

import PropTypes from "prop-types";

const useStepStyles = makeStyles(stepStyle);

export default function CustomStepper(props) {
  const classesStep = useStepStyles();
  const { activeStep, steps } = props;

  return (
    <Stepper
      activeStep={activeStep}
      alternativeLabel
      className={classesStep.root}
    >
      {steps.map((label, index) => (
        <Step key={label + index}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

CustomStepper.propTypes = {
  activeStep: PropTypes.number,
  steps: PropTypes.array
};
